
import moment from 'moment';


export default function operators(datatype) {
    const test = {
        text : 
        {
            exist : (compareval) => {
                return Boolean(compareval);
            },
            notexist : (compareval) => {
                return !test.text.exist(compareval);
            },
            equal : (val, compareval) => {
                if(test.text.notexist(compareval)) return test.text.notexist(val);
                return val.toString().toLowerCase() === compareval.toString().toLowerCase();
            },
            notequal : (val, compareval) => {
                return !test.text.equal(val, compareval);
            },
            startwith : (val, compareval) => test.text.regcompare(val, compareval, new RegExp(['^', val].join(''), 'i')),
            endwith : (val, compareval) => test.text.regcompare(val, compareval, new RegExp([val, '$'].join(''), 'i')),
            contain : (val, compareval) => test.text.regcompare(val, compareval, new RegExp(val, 'i')),
            notcontain : (val, compareval) => {
                return !test.text.contain(val, compareval);
            },
            regcompare : (val, compareval, rx) => {
                if(test.text.notexist(compareval)) return test.text.notexist(val);
                return rx.test(compareval);
            }
        },
        number : {
            notexist : (compareval) => {
                return isNaN(compareval);
            },
            exist : (compareval) => {
                return !test.number.notexist(compareval)
            },
            equal : (val, compareval) => {
                return Number(val) === Number(compareval);
            },
            notequal : (val, compareval) => {
                return !test.number.equal(val, compareval);
            },
            greater : (val, compareval) => {
                if(test.number.notexist(compareval)) return test.number.notexist(val);
                return Number(compareval) > Number(val);
            },
            less : (val, compareval) => {
                if(test.number.notexist(compareval)) return test.number.notexist(val);
                return Number(compareval) < Number(val);
            }
        },
        date : {
            exist : (compareval) => {
                return moment(compareval).isValid();
            },
            notexist : (compareval) => {
                return !test.date.exist(compareval);
            },
            equal : (val, compareval) => {
                if(test.date.notexist(compareval)) return test.text.equal(val, compareval);
                return moment(val).format('x') === moment(compareval).format('x');
            },
            notequal : (val, compareval) => {
                return !test.date.equal(val, compareval);
            },
            after : (val, compareval) => {
                if(test.date.notexist(compareval)) return false;
                if(test.date.notexist(val)) return true;
                return Number(moment(compareval).format('x')) > Number(moment(val).format('x'));
            },
            before : (val, compareval) => {
                if(test.date.notexist(compareval)) return test.date.exist(val);
                if(test.date.notexist(val)) return test.date.notexist(compareval);
                return Number(moment(compareval).format('x')) < Number(moment(val).format('x'));
            }
        },
        time : {
            todate : (val) => {
                if(typeof val === 'string') return ['2023-01-01', val.trim()].join(' ');
                return val;
            },
            exist : (compareval) => {
                if(!compareval) return false;
                return test.date.exist(test.time.todate(compareval));
            },
            notexist : (compareval) => {
                return !test.time.exist(compareval);
            },
            equal : (val, compareval) => {
                if(test.time.notexist(compareval)) return test.text.equal(val, compareval);
                return test.date.equal(test.time.todate(val), test.time.todate(compareval));
            },
            notequal : (val, compareval) => {
                return !test.time.equal(val, compareval);
            },
            after : (val, compareval) => {
                return test.date.after(test.time.todate(val), test.time.todate(compareval));
            },
            before : (val, compareval) => {
                return test.date.before(test.time.todate(val), test.time.todate(compareval));
            }
        },
        bool : {
            istrue : (compareval) => {
                return Boolean(compareval);
            },
            isfalse : (compareval) => {
                return !test.bool.istrue(compareval);
            }
        }
    }
    
    //TEXT: is, is not, contains, does not contain, is empty, is not empty
    const operators = [{
        id : 'txtequal',
        name : 'is',
        label : 'is equal to',
        test : test.text.equal,
        relevant : [
            'VARCHAR',
        ],
    }, {
        id : 'txtnotequal',
        name : 'is not',
        label : 'does not equal',
        test : test.text.notequal,
        relevant : [
            'VARCHAR',
        ],
    }, {
        id : 'txtstartwith',
        name : 'start is',
        label : 'starts with',
        test : test.text.startwith,
        relevant : [
            'VARCHAR'
        ]
    }, {
        id : 'txtendwith',
        name: 'end is',
        label: 'ends with',
        test : test.text.endwith,
        relevant : [
            'VARCHAR'
        ]
    }, {
        id : 'txtcontain',
        name : 'has',
        label : 'contains',
        test : test.text.contain,
        relevant : [
            'VARCHAR'
        ],
    }, {
        id : 'txtnotcontain',
        name : "has no",
        label : 'does not contain',
        test : test.text.notcontain,
        relevant : [
            'VARCHAR'
        ]
    }, {
        id : 'txtexist',
        name : 'exists',
        label : 'has a value',
        test : test.text.exist,
        notcompare : true,
        relevant : [
            'VARCHAR'
        ]
    }, {
        id : 'txtempty',
        name : 'is empty',
        label : 'has no value',
        test : test.text.notexist,
        notcompare : true,
        relevant : [
            'VARCHAR'
        ]
    }, {
        id : 'txtreg',
        name : 'matches',
        label : 'RegEx pattern',
        test : test.text.regcompare,
        relevant : [
            'VARCHAR'
        ]
    }
    //NUMBER: is, is not, greater than, less than, is empty, has value
    , {
        id : 'numequal',
        name : '=',
        label : 'equals',
        test : test.number.equal,
        relevant : [
            'INT', 'FLOAT', 'DECIMAL'
        ]
    }, {
        id : 'numnotequal',
        name : 'is not',
        label : 'does not equal',
        test : test.number.notequal,
        relevant : [
            'INT', 'FLOAT', 'DECIMAL'
        ]
    }, {
        id : 'numgreater',
        name : '>',
        label : 'greater than',
        test : test.number.greater,
        relevant : [
            'INT', 'FLOAT', 'DECIMAL'
        ]
    }, {
        id : 'numless',
        name : '<',
        label : 'less than',
        test : test.number.less,
        relevant : [
            'INT', 'FLOAT', 'DECIMAL'
        ]
    }, {
        id : 'numexist',
        name : 'has value',
        label : 'has a value',
        test : test.number.exist,
        notcompare : true,
        relevant : [
            'INT', 'FLOAT', 'DECIMAL'
        ]
    }, {
        id : 'numempty',
        name : 'is empty',
        label : 'has no value',
        test : test.number.notexist,
        notcompare : true,
        relevant : [
            'INT', 'FLOAT', 'DECIMAL'
        ]
    }
    //DATE is, is not, before, after, is empty, has value
    , {
        id : 'dateequal',
        name : 'is',
        label : 'equals',
        test : test.date.equal,
        relevant : [
            'DATE', 'DATETIME', 'TIMESTAMP'
        ]
    }, {
        id : 'datenot',
        name : 'is not',
        label : 'not equal to',
        test : test.date.notequal,
        relevant : [
            'DATE', 'DATETIME', 'TIMESTAMP'
        ]
    }, {
        id : 'datebefore',
        name : 'before',
        label : 'is before',
        test : test.date.before,
        relevant : [
            'DATE', 'DATETIME', 'TIMESTAMP'
        ]
    }, {
        id : 'dateafter',
        name : 'after',
        label : 'is after',
        test : test.date.after,
        relevant : [
            'DATE', 'DATETIME', 'TIMESTAMP'
        ]
    }, {
        id : 'dateexist',
        name : 'exists',
        label : 'is valid',
        test : test.date.exist,
        notcompare : true,
        relevant : [
            'DATE', 'DATETIME', 'TIMESTAMP'
        ]

    }, {
        id : 'dateempty',
        name : 'is empty',
        label : 'is not valid',
        notcompare : true,
        test : test.date.notexist,
        relevant : [
            'DATE', 'DATETIME', 'TIMESTAMP'
        ]
    }
    //TIME is, is not, before, after, is empty, has value
    , {
        id : 'timeis',
        name : 'is',
        label : 'equals',
        test : test.time.equal,
        relevant : [
            'TIME'
        ]
    }, {
        id : 'timenot',
        name : 'is not',
        label : 'not equal to',
        test : test.time.notequal,
        relevant : [
            'TIME'
        ]
    }, {
        id : 'timebefore',
        name : 'before',
        label : 'is before',
        test : test.time.before,
        relevant : [
            'TIME'
        ]
    }, {
        id : 'timeafter',
        name : 'after',
        label : 'is after',
        test : test.time.after,
        relevant : [
            'TIME'
        ]
    }, {
        id : 'timevalid',
        name : 'exists',
        label : 'is valid',
        test : test.date.exist,
        notcompare : true,
        relevant : [
            'TIME'
        ]

    }, {
        id : 'timeblank',
        name : 'is empty',
        label : 'is not valid',
        notcompare : true,
        test : test.date.notexist,
        relevant : [
            'TIME'
        ]
    }, {
        id : 'booltrue',
        name : 'Yes',
        label : 'is true',
        notcompare : true,
        test : test.bool.istrue,
        relevant : [
            'BOOLEAN'
        ]
    }, {
        id : 'boolfalse',
        name : 'No',
        label : 'is false',
        test : test.bool.isfalse,
        relevant : [
            'BOOLEAN'
        ]
    }];
    if(datatype) return operators.filter(n => n.relevant.includes(datatype.toUpperCase()));

    return operators;
    
}